// extracted by mini-css-extract-plugin
export var aboveInput = "_m6-0";
export var actionButton = "_m6-5";
export var actionButtonContainer = "_m6-1";
export var actionIcon = "_m6-6";
export var aiInfoContainer = "_m6-2";
export var attachmentWrapper = "_m6-7";
export var bold = "_m6-3";
export var checkIcon = "_m6-8";
export var clickingRecipientBar = "_m6-11";
export var commentThreadSwitch = "_m6-a";
export var draftImage = "_m6-b";
export var draftImageContainer = "_m6-c";
export var draftImages = "_m6-e";
export var editButton = "_m6-g";
export var editor = "_m6-f";
export var editorContainer = "_m6-y";
export var editorErrorTooltipWrapper = "_m6-9";
export var headerDivider = "_m6-h";
export var icon = "_m6-i";
export var info = "_m6-j";
export var internal = "_m6-n";
export var internalDivider = "_m6-k";
export var internalMessage = "_m6-l";
export var messageInputCard = "_m6-m";
export var messageInputForm = "_m6-o";
export var messageInputFormInternal = "_m6-p";
export var options = "_m6-q";
export var publicMessageCustomer = "_m6-s";
export var publicMessageMerchant = "_m6-r";
export var removeImageButton = "_m6-d";
export var replyButtons = "_m6-t";
export var showSignatureButton = "_m6-u";
export var spinner = "_m6-v";
export var verticalButtonDivider = "_m6-4";
export var visibilitySelector = "_m6-w";
export var warning = "_m6-x";
export var wrappingText = "_m6-z";
export var writingInternalNoteTopBorder = "_m6-10";